<template>

  <form @submit.prevent="onsubmit">
    <va-input
      v-model="email"
      type="email"
      :label="$t('auth.email')"
      :error="!!emailErrors.length"
      :error-messages="emailErrors"
    />
    <va-input
      v-model="password"
      type="password"
      :label="$t('auth.password')"
      :error="!!passwordErrors.length"
      :error-messages="passwordErrors"
    />

    <div class="d-flex justify--center mt-3">
      <va-button type="submit" class="my-0">{{ $t('auth.login') }}</va-button>
    </div>
  </form>
</template>

<script>

import authApi from '../../../api/auth'

export default {
  name: 'login',
  data () {
    return {
      email: '',
      password: '',
      keepLoggedIn: false,
      emailErrors: [],
      passwordErrors: [],
    }
  },
  computed: {
    formReady () {
      return !this.emailErrors.length && !this.passwordErrors.length
    },
  },
  methods: {
    onsubmit () {
      this.emailErrors = this.email ? [] : ['Email is required']
      this.passwordErrors = this.password ? [] : ['Password is required']
      if (!this.formReady) {
        return
      }
      authApi.login({
        email: this.email,
        password: this.password,
      }).then(response => {
        localStorage.setItem('token', response.token)
        localStorage.setItem('username', response.nickname)
        localStorage.setItem('employeeId', response.employeeId)
        this.$router.push({ name: this.$route.query.redirect === '/admin/openJob/interviewInbox' ? 'interviewInbox' : 'dashboard' })
      }).catch(() => {
        this.showToast(this.$t('auth.loginError'), {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
  },
}
</script>

<style lang="scss">
</style>
